'use client';
import {
  Pagination as PaginationComponent,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from '@/components/ui/pagination';
import { cn } from '@/utilities/cn';
import { useRouter } from 'next/navigation';
import React, { useMemo } from 'react';

export const Pagination: React.FC<{
  className?: string;
  page: number;
  totalPages: number;
}> = props => {
  const router = useRouter();

  const { className, page, totalPages } = props;

  const hasNextPage = page < totalPages;
  const hasPrevPage = page > 1;

  const pages = useMemo(() => {
    if (totalPages <= 5) return Array.from(Array(totalPages)).map((_, i) => i + 1);
    if (page <= 3) return [1, 2, 3, 4, 5];
    if (page >= totalPages - 2) return [totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    return [page - 2, page - 1, page, page + 1, page + 2];
  }, [page, totalPages]);

  const toPage = (pg: number) => {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('p', pg.toString());
    router.push(currentUrl.toString());
  };

  return (
    <div className={cn('my-12', className)}>
      <PaginationComponent>
        <PaginationContent>
          <PaginationItem>
            <PaginationPrevious
              disabled={!hasPrevPage}
              onClick={() => toPage(page - 1)}
            />
          </PaginationItem>
          {pages.map(pg => (
            <PaginationItem key={pg}>
              <PaginationLink
                isActive={pg === page}
                onClick={() => toPage(pg)}
              >
                {pg}
              </PaginationLink>
            </PaginationItem>
          ))}
          <PaginationItem>
            <PaginationNext
              disabled={!hasNextPage}
              onClick={() => toPage(page + 1)}
            />
          </PaginationItem>
        </PaginationContent>
      </PaginationComponent>
    </div>
  );
};
